import script from "./dialog-recharge.vue?vue&type=script&setup=true&lang=ts"
export * from "./dialog-recharge.vue?vue&type=script&setup=true&lang=ts"

import "./dialog-recharge.vue?vue&type=style&index=0&id=7c7d6e52&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c7d6e52"]])

export default __exports__